module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ch-box"
  }, [_c('h2', {
    staticClass: "ch-no"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("The Changing State of Children’s Health")]), _vm._v(" "), _c('p', {
    staticClass: "chimage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p39.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Healthy citizens are the greatest asset any country can have.")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Winston Churchill")]), _vm._v(" "), _c('h3', {
    staticClass: "sectionc"
  }, [_vm._v("We’re Number "), _c('span', {
    staticClass: "italicstyle"
  }, [_vm._v("What")]), _vm._v("? (Joanne)")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we began our research, one of our important tasks was to see if there actually had been a rise in children’s health conditions over the past few decades. When first setting out to do this, I had no idea how difficult it would be to find current health statistics for children, let alone come up with them from twenty to thirty years ago for comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My background in public health also made me curious about how we compared to other countries in both the health and well-being of children and mothers—so I decided to look into U.S. infant and maternal mortality statistics. When I did, I immediately called Christine and said, “Do you have any idea where the United States ranks among other countries in infant mortality? That’s how many infants die during the first year of life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” Christine said. “I’m sure we’re right up there, among the top three in the world?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Guess again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We aren’t in the top three?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We rank fifty-seventh! That means that fifty-six other countries have lower or better rates of infant mortality than the United States. Our child mortality rate is just as bad in comparison to other nations, and don’t even get me started on maternal mortality, which is the worst of all. This is unacceptable! Certainly we can do better than this! What are these other countries doing that we aren’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christine said nothing, before quietly responding, “Maybe the real question is, what are we doing that all these other countries aren’t?”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen we compared children’s health statistics from today to those from just a few decades ago we found increases in just about every health disorder we explored. Naturally, some proved to be more alarming than others, including the skyrocketing number of children with behavioral health disorders such as autism, ADHD, and bipolar disorder. We also found large increases in the number of children suffering from conditions such as diabetes, obesity, arthritis, and food allergies. The end result is that chronic disease and disability in U.S. children are now at an all-time high. A few decades ago it was rare for a child to have cancer or a life-threatening food allergy; today it is becoming far too common.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We realize that statistics are not everyone’s cup of tea. However, the graphs presented in this chapter are vital to understanding the many changes that have occurred in our country and the overall effects of these changes on our children’s health. They also serve to support the fundamental premise of our book:")]), _vm._v(" "), _c('p', {
    staticClass: "list-top"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" That many of our children suffer from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chronic")]), _vm._v(" health problems")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" That it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wasn’t")]), _vm._v(" always like this")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" That the problem is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("growing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("Below is a summary graphic highlighting some of the most notable increases we found in childhood health disorders over the past few decades. More detailed graphs regarding these statistics and many others follow.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p41.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feel free to browse, at your own pace, the more detailed graphs and related information that follow. Or you can simply skip ahead to the next chapter where we will discuss our findings. Before you begin, we have highlighted "), _c('span', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/book.jpg"
    }
  })]), _vm._v(" a few important points about health statistics and how to interpret our graphs. More information regarding children’s health statistics can be found in the "), _c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resource Guide")]), _vm._v(" in "), _c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" or at www.behindcloseddoorsthebook.com.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-title mid"
  }, [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "images/dull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A Little Background Information")])]), _vm._v(" "), _c('p', {
    staticClass: "listn-top"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" Most childhood illnesses or disorders are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" being tracked on a national level for incidence or prevalence (the number of new or new and existing cases), especially those that only affect a small number of children.")]), _vm._v(" "), _c('p', {
    staticClass: "listn"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" Often data from a small study published here or there is all that’s available for certain children’s health conditions, providing a very general estimate of the number of children affected.")]), _vm._v(" "), _c('p', {
    staticClass: "listn"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" Comparing any health statistic over time poses many different challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "listn"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" Sometimes even the definition of a childhood condition can change over the period of time health data is compared ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("autism")]), _vm._v(" vs. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("autism spectrum disorder")]), _vm._v("). Therefore, an “apples-to-apples” comparison is not always possible.")]), _vm._v(" "), _c('p', {
    staticClass: "listn"
  }, [_c('span', {
    staticClass: "lno"
  }, [_vm._v("•")]), _vm._v(" Health data takes time (often years) to be collected, analyzed, and published. As a result, a 2014 health statistic may be the most up-to-date statistical data available to use in 2017.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("How to Interpret the Graphs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/hai.jpg"
    }
  })]), _vm._v("Please know that the graphs and the statistical data derived from the graphs are meant to provide "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("general estimates")]), _vm._v(" of changes in various U.S. children’s health conditions over the past few decades. Each bar graph will attempt to show the comparison of the number of children diagnosed with a health condition today vs. the number of children diagnosed with the same condition twenty to thirty years ago. Sometimes the study data used in the graphs provide easy and clear comparisons, other times study data provided more challenging comparisons. Therefore, in an effort to provide both transparency and simplicity, we used an apple-to-apple, and apple-to-orange icon system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the data being compared over time was essentially the same (from the same study or the same survey) an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apple-to-apple")]), _vm._v(" icon was used. If the data being compared was from different studies or was challenging (because definitions or diagnostic tools changed) then an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apple-to-orange")]), _vm._v(" icon was used. For certain children’s health disorders an apple-to-orange comparison was the best we could do because it was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(" data available within the time period we needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following each graph, you will see bulleted text providing additional information regarding either the studies that support the graph or the particular children’s health condition displayed. In-graph citations are provided. Full references can be found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _vm._v(" of this book. And for the most up-to-date data, see www.behindcloseddoorsthebook.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p44.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p48.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p50.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p52.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p53.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p55.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p56.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p57.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p58.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p59.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p60.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p61.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p62.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36deca35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chap03.vue
// module id = 93
// module chunks = 0